import { render, staticRenderFns } from "./LinkInBio.vue?vue&type=template&id=97a62e5c&scoped=true"
import script from "./LinkInBio.vue?vue&type=script&lang=js"
export * from "./LinkInBio.vue?vue&type=script&lang=js"
import style0 from "./LinkInBio.vue?vue&type=style&index=0&id=97a62e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a62e5c",
  null
  
)

export default component.exports